// mrge / OneCPA enums sourced from their OpenAPI spec.
// Top traffic countries first; admins can type any ISO-3166 code, this
// dropdown lists the most common ones for one-click pickup.
export const MRGE_COUNTRIES = [
  "US", "GB", "CA", "AU", "DE", "FR", "ES", "IT", "NL", "BE", "SE", "DK",
  "NO", "FI", "IE", "AT", "CH", "PT", "PL", "CZ", "MX", "BR", "JP", "IN",
  "SG", "HK", "AE", "ZA", "NZ",
];

// All 25 OneCPA categories.
export const MRGE_CATEGORIES = [
  "ARTS_ENTERTAINMENT", "AUTOMOTIVE", "BUSINESS", "CAREERS", "EDUCATION",
  "FAMILY_PARENTING", "HEALTH_FITNESS", "FOOD_DRINK", "HOBBIES_INTERESTS",
  "HOME_GARDEN", "LAW_GOV_POLITICS", "ADULT", "NEWS", "PERSONAL_FINANCE",
  "SOCIETY", "PETS", "SPORTS", "STYLE_FASHION", "TECHNOLOGY_COMPUTING",
  "REAL_ESTATE", "TRAVEL", "SHOPPING", "RELIGION_SPIRITUALITY",
  "UNCATEGORIZED", "SCIENCE",
];

// Friendlier labels for the category dropdown.
export const MRGE_CATEGORY_LABELS = {
  ARTS_ENTERTAINMENT: "Arts & Entertainment",
  AUTOMOTIVE: "Automotive",
  BUSINESS: "Business",
  CAREERS: "Careers",
  EDUCATION: "Education",
  FAMILY_PARENTING: "Family & Parenting",
  HEALTH_FITNESS: "Health & Fitness",
  FOOD_DRINK: "Food & Drink",
  HOBBIES_INTERESTS: "Hobbies & Interests",
  HOME_GARDEN: "Home & Garden",
  LAW_GOV_POLITICS: "Law / Gov / Politics",
  ADULT: "Adult",
  NEWS: "News",
  PERSONAL_FINANCE: "Personal Finance",
  SOCIETY: "Society",
  PETS: "Pets",
  SPORTS: "Sports",
  STYLE_FASHION: "Style & Fashion",
  TECHNOLOGY_COMPUTING: "Technology & Computing",
  REAL_ESTATE: "Real Estate",
  TRAVEL: "Travel",
  SHOPPING: "Shopping",
  RELIGION_SPIRITUALITY: "Religion & Spirituality",
  UNCATEGORIZED: "Uncategorized",
  SCIENCE: "Science",
};

// Network filter chip definitions for the catalog page. Order is the
// admin's preferred ranking: Impact (largest feed) → Partnerize →
// Skimlinks → mrge → CJ → PubAdHub variants → AdMedia → FlexOffers → InMobi.
export const NETWORK_FILTER_OPTIONS = [
  { k: "all", label: "All" },
  { k: "impact", label: "Impact" },
  { k: "partnerize", label: "Partnerize" },
  { k: "skimlinks", label: "Skimlinks" },
  { k: "mrge", label: "mrge" },
  { k: "cj", label: "CJ" },
  { k: "pubadhub", label: "PubAdHub" },
  { k: "pubadhub_kevin", label: "PubAdHub 2" },
  { k: "admedia", label: "AdMedia" },
  { k: "flexoffers", label: "FlexOffers" },
  { k: "shopnomix_kevin", label: "Shopnomix InMobi" },
  { k: "siteplug", label: "Siteplug" },
  { k: "maxbounty", label: "MaxBounty" },
  { k: "cashbackhive", label: "CashbackHive" },
  { k: "giddyup", label: "GiddyUp" },
  { k: "rga", label: "ReallyGreatAds" },
  { k: "shopnomix", label: "Shopnomix" },
  { k: "pronomix", label: "Pronomix" },
];

// Per-network pill colour + label. Used by the catalog table cell so
// admins can spot the source feed at a glance. Falls back to a slate
// pill for unknown networks (manual/legacy rows).
export const NETWORK_PILL_CONFIG = {
  impact: { label: "Impact", cls: "bg-slate-100 text-slate-700" },
  partnerize: { label: "Partnerize", cls: "bg-indigo-50 text-indigo-700" },
  skimlinks: { label: "Skimlinks", cls: "bg-orange-50 text-orange-700" },
  mrge: { label: "mrge", cls: "bg-emerald-50 text-emerald-700" },
  cj: { label: "CJ", cls: "bg-amber-50 text-amber-700" },
  pubadhub: { label: "PubAdHub", cls: "bg-cyan-50 text-cyan-700" },
  pubadhub_kevin: { label: "PubAdHub 2", cls: "bg-teal-50 text-teal-700" },
  admedia: { label: "AdMedia", cls: "bg-rose-50 text-rose-700" },
  flexoffers: { label: "FlexOffers", cls: "bg-violet-50 text-violet-700" },
  shopnomix_kevin: { label: "Shopnomix InMobi", cls: "bg-fuchsia-50 text-fuchsia-700" },
  siteplug: { label: "Siteplug", cls: "bg-blue-50 text-blue-700" },
  maxbounty: { label: "MaxBounty", cls: "bg-cyan-50 text-cyan-700" },
  cashbackhive: { label: "CashbackHive", cls: "bg-teal-50 text-teal-700" },
  giddyup: { label: "GiddyUp", cls: "bg-teal-50 text-teal-700" },
  rga: { label: "ReallyGreatAds", cls: "bg-red-50 text-red-700" },
  shopnomix: { label: "Shopnomix", cls: "bg-lime-50 text-lime-700" },
  pronomix: { label: "Pronomix", cls: "bg-purple-50 text-purple-700" },
};

// Networks where "Add brand manually" is meaningful (create path).
// Edit/Audit/Delete are available for EVERY catalog brand — see BrandRowActions.
export const MANUAL_CREATE_NETWORKS = new Set([
  "pubadhub", "pubadhub_kevin", "shopnomix_kevin", "admedia", "manual",
]);

// Kept for callers that still import this name; edit actions are no longer
// gated on it (all feed partners are editable).
export const MANUAL_EDITABLE_NETWORKS = new Set([
  ...NETWORK_FILTER_OPTIONS.map((o) => o.k).filter((k) => k !== "all"),
  "manual",
]);

// Upstream-lookup chips shown on the empty-search prompt — networks
// that support real-time catalog search via /admin/networks/{n}/lookup-brand.
export const UPSTREAM_LOOKUP_NETWORKS = [
  "impact", "skimlinks", "mrge", "partnerize", "cj",
  "pubadhub", "pubadhub_kevin", "flexoffers", "siteplug", "maxbounty",
];
